import { render, staticRenderFns } from "./GallRomBibl.vue?vue&type=template&id=1ce8ee3a&scoped=true&"
import script from "./GallRomBibl.vue?vue&type=script&lang=js&"
export * from "./GallRomBibl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce8ee3a",
  null
  
)

export default component.exports